/**
 * Helper function to return "X-Client-Flights" header value to compose with
 * server flights
 *
 * Work Item 52715: Remove GF code (this function will be removed with this WI)
 */
export function getXClientFlightsHeaderValue(): string {
    // If user isn't in any flight, then no need to set header.
    return null;
}
